import React from 'react';
import Carousel from 'pages/OnlineStore/Carousel/Carousel';
import PropTypes from 'prop-types';
import styles from './LandingPage.css';
import PageHeader from './PageHeader';
import UpdateRequiredModal from '../GoStore/UpdateRequiredModal/UpdateRequiredModal';

class LandingPage extends React.Component {
  render() {
    const {
      icons,
      iconClassName,
      pageTitle,
      headingText,
      headingDescription,
      carouselImages,
      ctaText,
      ctaClassName,
      tncText,
      onClick,
      carouselPreviewClassName,
    } = this.props;

    return (
      <div className={styles.container}>
        <PageHeader
          icons={icons}
          title={pageTitle}
          iconClassName={iconClassName}
        />

        <div className={styles['sub-heading']}>
          <h2 className={styles['sub-title']}>{headingText}</h2>
          <p>{headingDescription}</p>
        </div>

        <Carousel
          items={carouselImages}
          previewClassName={carouselPreviewClassName}
        />

        <div className={styles.cta}>
          <button
            className={`btn btn-primary ${ctaClassName}`}
            onClick={onClick}
          >
            {ctaText}
          </button>
          {tncText}
        </div>

        {this._renderHowTo()}

        <UpdateRequiredModal />
      </div>
    );
  }

  _renderHowTo = () => {
    const { howToDescription, howToItems, howToUrl } = this.props;

    return (
      <div className={styles['how-to']}>
        <div>
          <strong>{howToDescription}</strong>
          <span className={styles['question-mark']}>?</span>
          <a className={styles.hint} href={howToUrl} target="_blank">
            Learn how this works
          </a>
        </div>
        <ul>
          {howToItems.map((item, index) => (
            <li key={`how-to-${index}`}>
              <span className="glyphicon glyphicon-ok" /> {item}
            </li>
          ))}
        </ul>
      </div>
    );
  };
}

LandingPage.propTypes = {
  icons: PropTypes.array,
  iconClassName: PropTypes.string,
  pageTitle: PropTypes.node,
  headingText: PropTypes.node,
  headingDescription: PropTypes.node,
  carouselImages: PropTypes.array,
  ctaText: PropTypes.string,
  howToDescription: PropTypes.string,
  howToItems: PropTypes.array,
  carouselPreviewClassName: PropTypes.string,
};

export default LandingPage;
